import React from "react";
import JobPostingThankYou from "../../components/job-posting/JobPostingThankYou";
import Footer from "src/components/common/Footer";

const JobPostingThankYouContainer: React.FC = () => {
  return <>     
      <JobPostingThankYou />
      <Footer variant="dashboard" />
  </>
  //return <JobPostingThankYou />;
};

export default JobPostingThankYouContainer;
